
import React from 'react';
import { connect } from "react-redux"
import { DashboardContainer } from "../../funcs/utils";
import UserPerformance from "../UserPerformance";
import {DEVICE, DEVICE_WIDTH} from "../../../lib/constants";
import {px_to_rem} from "../../helper/px";
import {sprintf} from "sprintf-js";

const Performance_ = props => {

  const component = props.component;
  const device = props.app.device;
  const device_width = Math.max(DEVICE_WIDTH[device], DEVICE_WIDTH.small);
  const device_rem = px_to_rem(device_width) - 10;
  const widthRem = sprintf("%.2frem", device_rem);
  const heightRem = sprintf("%.2frem", device_rem/2.);
  const do_small = device === DEVICE.tiny || device === DEVICE.small;
  const performance = component.getUserDashboard().performance;
  const device_prop = {
    width: props.app.width,
  }
  if (!performance || !performance.days_5 || performance.days_5.length < 5) {
    return null;
  }

  return (
    <DashboardContainer
      device={device_prop}
      client={props.client}
      title={"Performance"}>
      <UserPerformance
        smallLayout={do_small}
        data={performance}
        widthRem={widthRem}
        heightRem={heightRem}/>
    </DashboardContainer>
  )
}

const mapStateToProps = state => {
  return {
    app: state.app,
    client: state.client,
  }
}

const Performance = connect(mapStateToProps)(Performance_);

export { Performance };
